export enum CalendarDefaultDate {
    Today = "today",
    Earliest = "earliest",
    Latest = "latest",
}
